import xml2js from 'xml2js';

class AuthService {
    static GEOPORTAL_URL = "";
    // static GEOPORTAL_URL = "https://rk.geosamara.ru";

    static USER_EMPTY_URL = AuthService.GEOPORTAL_URL + "/user/empty.do?r=";
    static PASS_RECOVER_URL = AuthService.GEOPORTAL_URL + "/auth/passrecover.do";
    static SECURITY_CHECK_URL = AuthService.GEOPORTAL_URL + "/user/j_security_check";
    static AUTHS_USER_URL = AuthService.GEOPORTAL_URL + "/auths/user?r=";
    static AUTHS_CHECK_EMAIL_URL = AuthService.GEOPORTAL_URL + "/auths/user_exists?query=";
    static AUTH_LOGOUT_URL = AuthService.GEOPORTAL_URL + "/auth/logout/";

    static STATUS_OK = "OK";
    static STATUS_ERROR = "ERROR";

    static performEmailAuth(login, password, callback) {
        fetch(AuthService.USER_EMPTY_URL + Math.random(),
            {
                credentials: "same-origin"
            })
            .then(response => {
                if (!response.ok) throw Error(response.status);
                return response.text();
            })
            .then(response => {
                if (response === "") {
                    callback({ status: AuthService.STATUS_OK });
                } else {
                    var details = {
                        'j_username': login,
                        'j_password': password
                    };
                    var formBody = [];
                    for (var property in details) {
                        var encodedKey = encodeURIComponent(property);
                        var encodedValue = encodeURIComponent(details[property]);
                        formBody.push(encodedKey + "=" + encodedValue);
                    }

                    fetch(AuthService.SECURITY_CHECK_URL,
                        {
                            method: 'POST',
                            credentials: "same-origin",
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                            },
                            body: formBody.join("&"),
                        }).then((response) => {
                            if (!response.ok) throw Error(response.status);
                            return response.text();
                        }).then((response) => {
                            if (response === "") {
                                callback({ status: AuthService.STATUS_OK });
                            } else {
                                var parser = new xml2js.Parser();
                                parser.parseString(response, (error, result) => {
                                    if (error) {
                                        callback({
                                            status: AuthService.STATUS_ERROR,
                                            message: "Что-то пошло не так. Попробуйте еще раз."
                                        });
                                    } else {
                                        callback({
                                            status: AuthService.STATUS_ERROR,
                                            message: result.result.description[0]
                                        });
                                    }
                                });
                            }
                        })
                        .catch((error) => {
                            callback({
                                status: AuthService.STATUS_ERROR,
                                message: "Что-то пошло не так. Попробуйте еще раз."
                            })
                        }
                        );
                }
            });
    }

    static performLogout(callback) {
        fetch(AuthService.AUTH_LOGOUT_URL,
            {
                credentials: "same-origin"
            })
            .then((response) => {
                if (!response.ok) throw Error(response.status);
                return response.text();
            })
            .then((response) => {
                callback({ status: AuthService.STATUS_OK });
            })
            .catch(error => callback({ status: AuthService.STATUS_ERROR, message: error }));
    }


    static performRecoverAuth(login, callback) {
        fetch(AuthService.USER_EMPTY_URL + Math.random(),
            {
                credentials: "same-origin"
            })
            .then((response) => {
                if (!response.ok) throw Error(response.status);
                return response.text();
            })
            .then((response) => {
                if (response === "") {
                    callback({ status: AuthService.STATUS_OK });
                } else {
                    var details = {
                        'email': login
                    };
                    var formBody = [];
                    for (var property in details) {
                        var encodedKey = encodeURIComponent(property);
                        var encodedValue = encodeURIComponent(details[property]);
                        formBody.push(encodedKey + "=" + encodedValue);
                    }

                    fetch(AuthService.PASS_RECOVER_URL,
                        {
                            method: 'POST',
                            credentials: "same-origin",
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                            },
                            body: formBody.join("&"),
                        }).then((response) => {
                            if (!response.ok) throw Error(response.status);
                            return response.text();
                        })
                        .then((response) => {
                            callback({ status: AuthService.STATUS_OK });
                        })
                        .catch(error => callback({ status: AuthService.STATUS_ERROR, message: error }));
                }
            })
            .catch(error => callback({ status: AuthService.STATUS_ERROR, message: error }));
    }
}

export default AuthService;